import React, { useContext } from 'react';

import Storage from './Storage';

interface IStorageContext {
  storage?: Storage;
}

export const StorageContext = React.createContext<IStorageContext>({});

export const useStorageContext = () => useContext(StorageContext);
